import './convertCeremony.less';
import * as _ from 'lodash';

/**
 * @typedef { import('./ConvertCeremonyModel').ConvertCeremonyModel } ConvertCeremonyModel
 * @typedef { import('./ConvertCeremonyModel').CopyAttachmentModel } CopyAttachmentModel
 */

class ConvertCeremonyController {

    static $inject = ['tromanServer', 'downloadService', 'tromanGlobals'];

    constructor(tromanServer, downloadService, _tromanGlobals) {
        this._tromanServer = tromanServer;
        this._downloadService = downloadService;
        /** @type {ConvertCeremonyModel} */
        this.model = null;
    }

    attachmentSelectionChanged() {
        if (!this.model) return;
        this.model.calculateRenames();
    }

    /**
     * 
     * @param {CopyAttachmentModel} model 
     */
    downloadFile(model) {
        this._tromanServer.Files.downloadAttachment(model.attachment.Id)
            .then(rsp => this._downloadService.downloadBlob(rsp.blob, rsp.filename));
    }
}

angular.module("tromanWeb").component('ergoConvertCeremony', {
    template: require('./convertCeremony.html'),
    bindings: {
        model: '<',
        organizations: '<',
        wageCalculations: '<',
    },
    controller: ConvertCeremonyController
});

